export default __webpack_public_path__ + "static/media/dunce.8bf81ba2.jpg";